// extracted by mini-css-extract-plugin
export var bodyRow = "_ee-d";
export var cardColumns = "_ee-e";
export var ellipsesOverflow = "_ee-2";
export var flatBottomCorners = "_ee-3";
export var flatTopCorners = "_ee-4";
export var headerActionsDropdown = "_ee-f";
export var headerBottomRow = "_ee-c";
export var headerTopRow = "_ee-b";
export var orderDetailsWrapper = "_ee-0";
export var orderInfoContainer = "_ee-1";
export var productDetails = "_ee-9";
export var productImage = "_ee-5";
export var responsiveTable = "_ee-8";
export var shipmentContainer = "_ee-a";
export var tableBottomLeft = "_ee-6";
export var tableBottomRight = "_ee-7";
export var trackingLink = "_ee-g";